import React, { useState, useCallback } from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import { LayoutGrid, Building2, Users } from 'lucide-react';
import { Tokens, Toast } from './SharedUI';
import OrganizationDetail from './OrganizationDetail';
import { SubscriptionsView} from './Subscription';
import { PlansView } from './PlanView';
import { OrganizationsView } from './OrganizationsView';
import { Card, Flex } from '@chakra-ui/react';

const NAV = [
  { id: 'organizations', label: 'Organization', icon: Users },
  { id: 'subscriptions', label: 'Subscription', icon: Building2 },
  { id: 'plans', label: 'Plan', icon: LayoutGrid },
];

export default function SuperadminDashboard() {
  const [tabIndex, setTabIndex] = useState(0);
  const [openOrgId, setOpenOrgId] = useState(null);
  const [toast, setToast] = useState(null);
  const [orgsCache, setOrgsCache] = useState([]);
  const [plansCache, setPlansCache] = useState([]);

  const notify = useCallback((message, type = 'success') => setToast({ message, type }), []);

  return (
    <Flex
      minH="100vh"
      pt="48px"          // space for fixed header
      align="center"     // vertical center
      justify="center"   // horizontal center
      px="20px"
    >
      <Card
        className="sa-root sa-superadmin-dashboard"
        w="100%"
        maxW="1800px"
        minH="700px"
      >
         <div className="sa-root sa-scan">
      <Tokens />
      <div className="flex" style={{ minHeight: '100vh'}}>
        {/* MAIN */}
  <main
  className="flex-1 sa-scrollbar overflow-y-auto"
  style={{
    maxHeight: '100vh',
    width: '100%',
    padding: '32px 40px',
    boxSizing: 'border-box',
  }}
>
  <div
    style={{
      width: '100%',
      maxWidth: 'none',
      margin: 0,
    }}
  >
    {openOrgId ? (
      <OrganizationDetail
        orgId={openOrgId}
        orgs={orgsCache}
        plans={plansCache}
        notify={notify}
        onBack={() => setOpenOrgId(null)}
      />
    ) : (
      <Tabs
        variant="unstyled"
        index={tabIndex}
        onChange={setTabIndex}
      >
        <TabList
          width="fit-content"
          border="1px solid #e2e8f0"
          borderRadius="6px"
          p="2px"
          gap="2px"
        >
          {NAV.map((n) => (
            <Tab
              key={n.id}
              fontSize="13px"
              fontWeight="medium"
              px="12px"
              py="6px"
              display="flex"
              alignItems="center"
              gap="6px"
              _selected={{
                border: '1px solid #3182CE',
                color: '#3182CE',
                bg: 'white',
                borderRadius: '4px',
              }}
            >
              <n.icon size={14} />
              {n.label}
            </Tab>
          ))}
        </TabList>

        <TabPanels mt={5}>
          <TabPanel p={0}>
            <OrganizationsView
              notify={notify}
              onOpenOrg={setOpenOrgId}
              setOrgsCache={setOrgsCache}
            />
          </TabPanel>

          <TabPanel p={0}>
            <SubscriptionsView
              notify={notify}
              onOpenOrg={setOpenOrgId}
              setOrgsCache={setOrgsCache}
            />
          </TabPanel>

          <TabPanel p={0}>
            <PlansView
              notify={notify}
              setPlansCache={setPlansCache}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    )}
  </div>
</main>
      </div>

      <Toast toast={toast} onDone={() => setToast(null)} />
    </div>
       
      </Card>
    </Flex>
  );
}
